import SellerBuyerCard from "../../Components/SellerBuyerCard/SellerBuyerCard";
import userimgg from "../../Assets/images/userimgg.png";
import cup from "../../Assets/images/cup.svg";
import usser2 from "../../Assets/images/usser2.png";
import usser3 from "../../Assets/images/usser3.png";
import usser4 from "../../Assets/images/usser4.png";
import iconsLightningLine from "../../Assets/images/iconsLightningLine.svg";
import usser5 from "../../Assets/images/usser5.png";
import iconsDoughnutLine from "../../Assets/images/iconsDoughnutLine.svg";
import userrr2 from "../../Assets/images/userrr2.png";

const Data = [
  {
    name: "Payton Harris",
    numbers: "#1",
    userimgg: userimgg,
    ETHnum: 2.456,
    img1: cup,
    colr: "#3772FF",
  },
  {
    name: "Odell Hane",
    numbers: "#2",
    userimgg: userrr2,
    ETHnum: 2.456,
    img1: cup,
    colr: "#9757D7",
  },

  {
    name: "Marlee Kuphal",
    numbers: "#3",
    userimgg: usser3,
    ETHnum: 2.456,
    img1: iconsLightningLine,
    colr: "#45B26B",
  },
  {
    name: "Payton Kunde",
    numbers: "#4",
    userimgg: usser4,
    ETHnum: 2.456,
    img1: iconsDoughnutLine,
    colr: "#000000",
  },
  {
    name: "Payton Buckridge",
    numbers: "#5",
    userimgg: usser5,
    ETHnum: 2.456,
    img1: cup,
    colr: "#000000",
  },
  {
    name: "Payton Harris",
    numbers: "#3",
    userimgg: usser3,
    ETHnum: 2.456,
    img1: iconsLightningLine,
    colr: "#45B26B",
  },
  {
    name: "Payton Harris",
    numbers: "#5",
    userimgg: usser5,
    ETHnum: 2.456,
    img1: cup,
    colr: "#000000",
  },
  {
    name: "Payton Harris",
    numbers: "#3",
    userimgg: usser3,
    ETHnum: 2.456,
    img1: iconsLightningLine,
    colr: "#45B26B",
  },
];
export default Data;
